import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="w-full max-w-lg">
        <span className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-3xl">
          <i className="ri-compass-3-line"></i>
        </span>
        <p className="mt-6 text-6xl font-black text-primary-500">404</p>
        <h1 className="mt-4 text-xl font-bold text-foreground-950">
          الصفحة غير موجودة
        </h1>
        <p className="mt-2 text-sm leading-7 text-foreground-500">
          عذرًا، الصفحة التي تبحث عنها غير متاحة أو تم نقلها. يمكنك العودة إلى
          لوحة التحكم والمتابعة من هناك.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center gap-2 h-11 rounded-btn bg-primary-500 px-6 text-sm font-semibold text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-5-line"></i>
          العودة إلى الرئيسية
        </Link>
      </div>
    </div>
  );
}